import { TimePicker } from '@mui/x-date-pickers'
import { useState } from 'react'
import { TextField } from '@mui/material'
import moment from 'moment'

const MUITimePicker = ({
    handleChange,
    value,
    disabled = false,
    timeFormat = 'D MMMM YYYY',
    label = '',
    fieldProps = {},
    customComponents = {},
    customComponentsProps = {},
}) => {
    const [open, setOpen] = useState(false)

    return (
        <TimePicker
            open={open}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            value={moment(value)}
            onChange={(e) => {
                handleChange(e)
            }}
            disabled={disabled}
            slots={{
                field: TextField,
                ...customComponents,
            }}
            slotProps={{
                field: {
                    onClick: () => {
                        if (disabled) return
                        setOpen((open) => !open)
                    }, // Trigger picker on click
                    label: label,
                    clearable: true,
                    type: 'text',
                    value: value
                        ? moment.utc(value).local().format(timeFormat)
                        : '',
                    InputLabelProps: {
                        shrink: true,
                    },
                    inputProps: {
                        readOnly: 'true',
                    },
                    ...fieldProps,
                },
                openPickerButton: {
                    onClick: (e) => {
                        e.preventDefault()
                    },
                    sx: { display: 'none' },
                },
                ...customComponentsProps,
            }}
        />
    )
}

export default MUITimePicker
